import {Query, gql} from 'apollo-angular';
import { Injectable } from '@angular/core';



@Injectable({
    providedIn: 'root'
})
export class ParkLogbookQuery extends Query<any> {
    document = gql`
        query Turbines($serialNav: Float, $startTS: Float!, $endTS: Float!) {
            turbines(where: { serialNav: $serialNav }) {
                park {
                    _id
                    name
                    parkLogbook(startTS: $startTS, endTS: $endTS) {
                        tcu
                        startTS
                        endTS
                        mutTS
                        userComment
                        _id_process
                        turbine {
                            name
                            code : codeDisplay
                            serialNav
                        }
                    }
                }
            }
        }
    `;
}

@Injectable({
  providedIn: 'root'
})
export class ParkTclassBlockQuery extends Query<any> {
    document = gql`
        query Parks($park: String!, $startTS: Float!, $endTS: Float!, $turbineIds: [ID!]) {
            parks(where: {name: $park}, turbines: $turbineIds) {
                name
                parkLogbook(startTS: $startTS, endTS: $endTS) {
                    _id
                    _id_turbine
                    _id_alarm
                    _id_process
                    startTS
                    endTS
                    tc
                    tcu
                    ack
                    log
                    component
                    mutTS
                    userComment
                    edited
                    customEvent
                    totalProductionLoss
                    totalRevenueLoss
                    deleted
                    isOpen
                    subBlocks
                    lossesMethod
                    amLossesComment
                    tcmLossesComment
                    lossesConfirmed
                    blockActionsLog
                    eventCode
                    eventDescription
                    controlroomAck
                    controlroomAckLog
                    controlroomTicketing
                    controlroomTicketingLog
                    turbine {
                        name
                        code : codeDisplay
                        serialNav
                        productionLossMethod {
                          production_loss_calculation {
                              method
                              calculation_method
                              references {
                                  _id
                                  name
                              }
                          }
                        }
                    }
                }
            }
        }
    `;
}

// @Injectable({
//   providedIn: 'root'
// })
// export class ParkTclassBlockQuery extends Query<any> {
//     document = gql`
//         query Parks($park: String!, $startTS: Float!, $endTS: Float!) {
//             parks(where: {name: $park}) {
//                 name
//                 parkLogbook(startTS: $startTS, endTS: $endTS) {
//                     tcu
//                     startTS
//                     endTS
//                     mutTS
//                     isOpen
//                     turbine {
//                         name
//                         code
//                         serialNav
//                     }
//                 }
//             }
//         }
//     `;
// }

@Injectable({
    providedIn: 'root'
})
export class ParkLogbookLossesQuery extends Query<any> {
    document = gql`
        query ParkLogbook($name: String!, $startTS: Float!, $endTS: Float!, $turbineIds: [ID!]) {
            parks(where: { name: $name }, turbines: $turbineIds) {
                turbines {
                    productionLossMethod {
                        _id
                        code
                        serialNav
                        production_loss_calculation {
                            method
                            calculation_method
                            references {
                                _id
                                name
                            }
                        }
                    }
                }
                parkLogbookLosses(startTS: $startTS, endTS: $endTS) {
                    _id
                    _id_turbine
                    _id_alarm
                    _id_process
                    startTS
                    endTS
                    tc
                    tcu
                    ack
                    log
                    component
                    mutTS
                    userComment
                    edited
                    customEvent
                    totalProductionLoss
                    totalRevenueLoss
                    deleted
                    isOpen
                    subBlocks
                    lossesMethod
                    amLossesComment
                    tcmLossesComment
                    lossesConfirmed
                    blockActionsLog
                    eventCode
                    eventDescription
                    controlroomAck
                    controlroomAckLog
                    controlroomTicketing
                    controlroomTicketingLog
                    turbine {
                        name
                        code : codeDisplay
                        serialNav
                    }
                }
            }
        }
    `;
}
